import { render, staticRenderFns } from "./ProRiskCanvasList.vue?vue&type=template&id=770a7e5b&"
import script from "./ProRiskCanvasList.vue?vue&type=script&lang=js&"
export * from "./ProRiskCanvasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports